<!-- 品质证书 -->
<template>
    <div class='head_boxs'>
        <phoneCarousel :list="webDate.phoneCertificateTop" height="16.25rem" v-if="webDate"></phoneCarousel>
        <phoneCarousel :list="webDate.phoneCertificateBanner" :fullScreen="true"></phoneCarousel>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex'
import phoneCarousel from "@/components/phoneCarousel.vue"
const store = useStore()
const webDate = computed(() => store.state.webDate);
</script>

<style scoped lang='scss'>
.head_boxs {
    width: 100%;
    padding-top: 52px;
    width: 100%;
}
</style>